import { unhandledRequest } from '../request';

export type BlacklistedEmail = {
  id: number;
  email: string;
  description: string;
};

export async function loadBlacklistedEmails() {
  const response = await unhandledRequest.get<BlacklistedEmail[]>({
    url: '/blacklist/',
  });
  return response.data;
}

export async function createBlockedEmail(data: BlacklistedEmail) {
  return await unhandledRequest.post({
    url: '/blacklist/',
    data,
  });
}

export async function updateBlockedEmail(data: BlacklistedEmail) {
  return await unhandledRequest.patch({
    url: `/blacklist/${data.id}/`,
    data,
  });
}

export async function deleteBlockedEmail(id: number) {
  return await unhandledRequest.delete({
    url: `/blacklist/${id}/`,
  });
}
